import React from "react";
import WithAuth from "../hoc/WithAuth";
import BranchesTable from "../components/tables/BranchesTable";

function BranchesPage() {
  return (
    <div
      style={{
        borderRadius: 8.5,
        marginTop: 25,
        paddingLeft: 50,
        paddingRight: 50,
        paddingTop: 22,
        backgroundColor: "white",
      }}
    >
      {/* <InputModal open={open} selectedId={selectedId} hideModal={hideModal} /> */}
      <BranchesTable />
    </div>
  );
}

export default WithAuth(BranchesPage);
